export default __webpack_public_path__ + "static/media/smartApyLogo.b2939241.svg";